import React from "react";
import { Flex, Typography } from "antd";
import ZipCodeInput from "./ZipCodeInput";
import ZipCodeList from "./ZipCodeList";
import RulesList from "./RulesList";
import DefaultMessageInput from "./DefaultMessageInput";

const { Title, Text } = Typography;

function OutsideZoneConfig({ outsideZone, setOutsideZone, zipCodesList, setZipCodesList }) {
  return (
    <div className="bg-white shadow-md rounded-lg p-6 mb-6 flex flex-col gap-6 items-start w-full">
      <Flex align="center" gap={8}>
        <div style={{ 
          width: "8px", 
          height: "8px", 
          backgroundColor: "#faad14", 
          borderRadius: "50%" 
        }} />
        <Title level={5} style={{ margin: 0, color: "#262626" }}>
          Outside Service Area (Optional)
        </Title>
      </Flex>
      
      <div className="flex flex-col gap-1 w-full items-start" style={{ marginTop: "-8px" }}>
        <Text type="secondary" style={{ fontSize: "13px", lineHeight: "1.5" }}>
          Add zip codes for areas you serve with limitations. Configure travel add-on notices based on trade, service type, and specific jobs.
        </Text>
      </div>

      <ZipCodeInput
        zone="outside"
        zipCodesList={zipCodesList}
        setZipCodesList={setZipCodesList}
        outsideZone={outsideZone}
        setOutsideZone={setOutsideZone}
      />

      <ZipCodeList
        zone="outside"
        zipCodes={outsideZone.zipCodes}
        onRemove={(zip) => setOutsideZone({
          ...outsideZone,
          zipCodes: outsideZone.zipCodes.filter((e) => e !== zip)
        })}
        onMove={(zip) => {
          setOutsideZone({
            ...outsideZone,
            zipCodes: outsideZone.zipCodes.filter((e) => e !== zip)
          });
          setZipCodesList([...new Set([...zipCodesList, zip])]);
        }}
      />

      <RulesList
        rules={outsideZone.rules}
        onUpdateRules={(updatedRules) => setOutsideZone({ ...outsideZone, rules: updatedRules })}
      />

      <DefaultMessageInput
        defaultMessage={outsideZone.defaultMessage}
        onChange={(e) => setOutsideZone({ ...outsideZone, defaultMessage: e.target.value })}
      />
    </div>
  );
}

export default OutsideZoneConfig;
